var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { getDayMonthYearWithSpace } from '@domain-group/fe-allhomes-library';
import ListingAvailability from './listing-availability';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingAvailability on Property {\n    listing {\n      availableNow\n      availableTo\n      availableFrom\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing;
  return {
    availableNow: listing.availableNow,
    dateTo: getDayMonthYearWithSpace(listing.availableTo),
    dateFrom: getDayMonthYearWithSpace(listing.availableFrom)
  };
};
var ListingAvailabilityGraphQL = _ref2 => {
  var property = _ref2.property;
  return ___EmotionJSX(ListingAvailability, graphQLToProps(property));
};
ListingAvailabilityGraphQL.fragment = fragment;
ListingAvailabilityGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      availableNow: PropTypes.bool,
      availableTo: PropTypes.string,
      availableFrom: PropTypes.string
    })
  })
};
ListingAvailabilityGraphQL.defaultProps = {
  property: {}
};
export default ListingAvailabilityGraphQL;